import React, { useState, useEffect } from "react";
import { apiClient } from "../../../services/api/apiClient";
import HVAC from "./HVACTab";
import Plumbing from "./PlumbingTab";
// import HangerTable from "./HangerTable";

function Hangers({
  submittalId,
  activeTrade,
  activeSubTab,
  onTradeChange,
  onSubTabChange,
  onEditHanger,
  onDeleteHanger,
  onEditSpacing,
  onDeleteSpacing,
  onEditRiserClamp,
  onDeleteRiserClamp,
  onEditUnistrut,
  onDeleteUnistrut,
}) {
  const [allData, setAllData] = useState({
    hangers: [],
    spacing: [],
    riserClamps: [],
    unistrut: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHangersData = async () => {
      if (!submittalId) return;

      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get(`/hangers/${submittalId}`);
        const data = response.data;
        setAllData({
          hangers: data.hangers || [],
          spacing: data.spacing || [],
          riserClamps: data.riserClamps || [],
          unistrut: data.unistrut || [],
        });
      } catch (err) {
        console.error("Error fetching hangers data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHangersData();
  }, [submittalId]);

  const getDataByTrade = (trade) => {
    return {
      hangers: allData.hangers.filter((item) => item.trade === trade),
      spacing: allData.spacing.filter((item) => item.trade === trade),
      riserClamps: allData.riserClamps.filter((item) => item.trade === trade),
      unistrut: allData.unistrut.filter((item) => item.trade === trade),
    };
  };

  const hvacData = getDataByTrade("HVAC");
  const plumbingData = getDataByTrade("Plumbing");

  return (
    <div className="w-full">
      {/* Tab Navigation */}
      <div className="flex border-b-2 border-gray-200 mb-5">
        <button
          className={`px-6 py-3 text-base font-medium border-b-2 transition-all duration-300 ease-in-out ${
            activeTrade === "HVAC"
              ? "text-indigo-600 border-indigo-600 bg-slate-50"
              : "text-gray-500 border-transparent hover:text-indigo-600 hover:bg-slate-50"
          }`}
          onClick={() => onTradeChange("HVAC")}
        >
          HVAC
        </button>
        <button
          className={`px-6 py-3 text-base font-medium border-b-2 transition-all duration-300 ease-in-out ${
            activeTrade === "Plumbing"
              ? "text-indigo-600 border-indigo-600 bg-slate-50"
              : "text-gray-500 border-transparent hover:text-indigo-600 hover:bg-slate-50"
          }`}
          onClick={() => onTradeChange("Plumbing")}
        >
          Plumbing
        </button>
      </div>

      {/* Loading and Error States */}
      {loading && (
        <div className="min-h-[200px] py-5 flex items-center justify-center">
          <p>Loading hangers data...</p>
        </div>
      )}

      {error && (
        <div className="min-h-[200px] py-5 flex items-center justify-center">
          <p className="text-red-500">Error loading hangers: {error}</p>
        </div>
      )}

      {/* Tab Content */}
      {!loading && !error && (
        <div className="min-h-[200px] py-5">
          {activeTrade === "HVAC" && (
            <HVAC
              allData={hvacData}
              activeSubTab={activeSubTab}
              onSubTabChange={onSubTabChange}
              onEditHanger={onEditHanger}
              onDeleteHanger={onDeleteHanger}
              onEditSpacing={onEditSpacing}
              onDeleteSpacing={onDeleteSpacing}
              onEditRiserClamp={onEditRiserClamp}
              onDeleteRiserClamp={onDeleteRiserClamp}
              onEditUnistrut={onEditUnistrut}
              onDeleteUnistrut={onDeleteUnistrut}
            />
          )}
          {activeTrade === "Plumbing" && (
            <Plumbing
              allData={plumbingData}
              activeSubTab={activeSubTab}
              onSubTabChange={onSubTabChange}
              onEditHanger={onEditHanger}
              onDeleteHanger={onDeleteHanger}
              onEditSpacing={onEditSpacing}
              onDeleteSpacing={onDeleteSpacing}
              onEditRiserClamp={onEditRiserClamp}
              onDeleteRiserClamp={onDeleteRiserClamp}
              onEditUnistrut={onEditUnistrut}
              onDeleteUnistrut={onDeleteUnistrut}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default Hangers;
